import { Accordion } from '@streamelements/frontend-ui';
import { ComponentProps, PropsWithChildren } from 'react';

export function TargetsSettingsList({ children, ...props }: PropsWithChildren<ComponentProps<typeof Accordion.Root>>) {
  return <Accordion.Root {...props}>{children}</Accordion.Root>;
}
